import { create } from 'zustand';

export enum MODAL_TYPE {
  CLOSE = 'close',
  CHECK_TICKET = 'checkTicket',
  CHECK_MAIN_TICKET = 'checkMainTicket',
  CHECK_SIDE_TICKET = 'checkSideTicket',
  CHECK_ANY_TICKET = 'checkAnyTicket',
  IS_AGREE_PRIVACY = 'isAgreePrivacy',
  REAL_NOT_AGREE = 'realNotAgree',
  CHECK_AGREE = 'checkAgree',
  COMPLETE_AGREE = 'completeAgree',
  NOT_START = 'notStart',
}

// 인터페이스 정의
interface ModalState {
  isVisibleCommon: boolean;
  isVisiblePrivacy: boolean;
  isVisibleEndDate: boolean;
  modalType: MODAL_TYPE;
  commonCallback1: null | (() => void);
  commonCallback2: null | (() => void);
  showModal: ({
    modalType,
    commonCallback1,
    commonCallback2,
  }: {
    modalType: MODAL_TYPE;
    commonCallback1?: () => void;
    commonCallback2?: () => void;
  }) => void;
  hideModal: () => void;
  showPrivacyModal: () => void;
  hidePrivacyModal: () => void;
  hideIsVisibleEndDate: () => void;
  showIsVisibleEndDate: () => void;
}

// Zustand 스토어 생성
const modalStore = create<ModalState>((set) => ({
  isVisibleCommon: false,
  isVisiblePrivacy: false,
  isVisibleEndDate: false,
  commonCallback1: null,
  commonCallback2: null,
  modalType: MODAL_TYPE.CLOSE,
  showModal: ({ modalType, commonCallback1, commonCallback2 }) =>
    set({ isVisibleCommon: true, modalType, commonCallback1, commonCallback2 }),
  hideModal: () =>
    set({
      isVisibleCommon: false,
      modalType: MODAL_TYPE.CLOSE,
      commonCallback1: null,
      commonCallback2: null,
    }),
  showPrivacyModal: () => set({ isVisiblePrivacy: true }),
  hidePrivacyModal: () => set({ isVisiblePrivacy: false }),
  hideIsVisibleEndDate: () => set({ isVisibleEndDate: false }),
  showIsVisibleEndDate: () => set({ isVisibleEndDate: true }),
}));

export { modalStore };
